import {
    loginByUsername,
    logout,
    getUserInfo
} from '@/api/login'
import {
    getMenuList
} from '@/api/menu'
import {
    getToken,
    setToken,
    removeToken
} from '@/util/auth'

const user = {
    state: {
        user: '',
        status: '',
        code: '',
        token: getToken(),
        name: '',
        avatar: '',
        introduction: '',
        roles: [],
        menus: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {
        SET_USER: (state, user) => {
            state.user = user
        },
        SET_CODE: (state, code) => {
            state.code = code
        },
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_INTRODUCTION: (state, introduction) => {
            state.introduction = introduction
        },
        SET_SETTING: (state, setting) => {
            state.setting = setting
        },
        SET_STATUS: (state, status) => {
            state.status = status
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_MENUS: (state, menus) => {
            state.menus = menus
        }
    },

    actions: {
        // 用户名登录
        LoginByUsername({
            commit
        }, userInfo) {
            const username = userInfo.username.trim()
            return new Promise((resolve, reject) => {
                loginByUsername(username, userInfo.password).then(response => {
                    if (response.code == 200) {
                        setToken(response.data.token);
                        localStorage.setItem('username', response.data.name);
						localStorage.setItem('roleId', response.data.roleId);
                        resolve(response);
                    } else {
                        reject(response.msg);
                    }
                }).catch(error => {
                    reject(error);
                })
            })
        },

        // 获取用户信息
        GetUserInfo({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                getUserInfo({}).then(response => {
                    const data = response.user
                    commit('SET_ROLES', data.roleIdList)
                    commit('SET_NAME', data.username)
                    commit('SET_AVATAR', "")
                    commit('SET_INTRODUCTION', "")
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        GetUserMenu({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                getMenuList({
                    showLoading: true
                }).then(response => {
                    let list = [];
                    if (response.menuList.length > 0) {
                        for (let i = 0; i < response.menuList.length; i++) {
                            list.push(response.menuList[i].name)
                            if (response.menuList[i].list != null) {
                                for (let j = 0; j < response.menuList[i].list.length; j++) {
                                    list.push(response.menuList[i].list[j].name)
                                }
                            }
                        }
                    }
                    commit('SET_MENUS', list);
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 第三方验证登录
        // LoginByThirdparty({ commit, state }, code) {
        //   return new Promise((resolve, reject) => {
        //     commit('SET_CODE', code)
        //     loginByThirdparty(state.status, state.email, state.code).then(response => {
        //       commit('SET_TOKEN', response.data.token)
        //       setToken(response.data.token)
        //       resolve()
        //     }).catch(error => {
        //       reject(error)
        //     })
        //   })
        // },

        // 登出
        LogOut({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                removeToken()
                resolve()
                // logout(state.token).then(() => {
                //   commit('SET_TOKEN', '')
                //   commit('SET_ROLES', [])
                //   removeToken()
                //   resolve()
                // }).catch(error => {
                //   reject(error)
                // })
            })
        },

        // 前端 登出
        FedLogOut({
            commit
        }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                resolve()
            })
        },

        // 动态修改权限
        ChangeRole({
            commit
        }, role) {
            return new Promise(resolve => {
                commit('SET_TOKEN', role)
                setToken(role)
                getUserInfo(role).then(response => {
                    const data = response.data
                    console.log(data);
                    commit('SET_ROLES', data.role)
                    commit('SET_NAME', data.name)
                    commit('SET_AVATAR', data.avatar)
                    commit('SET_INTRODUCTION', data.introduction)
                    resolve()
                })
            })
        }
    }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js